<ng-container feature *ngFor="let device of gatewayDevices.getVitotrolDevices$ | async">
  <ng-container *ngrxLet="getLqiFeature(device.device.id) as feature">
    <app-feature-tile
      *ngrxLet="getDeviceDescription(device.device.id) as description"
      label="{{ '+INSTALLATIONS.SRC.ETRV.WIFI_LQI_STRENGTH.TITLE' | translate }}"
      description="{{ description | value2: featurePropertyKey.name }}"
      value="{{ feature | value2: featurePropertyKey.strength }} {{
        feature | unit: featurePropertyKey.strength
      }}"
      [attr.data-feature]="feature?.feature"
      [error]="
        (feature | error) ||
        (feature?.properties?.strength &&
          feature?.properties?.strength?.value < lowLqiSignalThreshold)
      "
      [class.lqi-warning]="
        feature?.properties?.strength &&
        feature?.properties?.strength?.value < lowLqiSignalThreshold
      "
      [iconVariant]="iconVariant.error"
      informationTooltip="{{
        '+INSTALLATIONS.INSTALLATION.VITOTROL_LQI_STRENGTH.TOOLTIP' | translate
      }}"
      [showInformationTooltip]="
        feature?.properties?.strength &&
        feature?.properties?.strength?.value < lowLqiSignalThreshold
      "
    >
    </app-feature-tile>
  </ng-container>
</ng-container>
